import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Input, Card, message, Select, Spin, Icon, Tag } from "antd";
import Cookies from "js-cookie";
import axios from "axios";
import { withRouter } from "react-router-dom";
import CustomAgGridTable from "../../../Common-Table/CustomAgGridTable";
import F from "../../../Functions";
import "../ManageSchedulers/ManageScheduler.css";



// store 
import { useBoundStore } from "../../../store/useBoundStore";





// assets imports
import RefreshIcon from "../../../assets/refresh-icon.png";
import ActionButtonRenderer from "./ActionButtonRenderer";
import { GET_ROLES_API, INACTIVE_LOAD_USERS_API_URL, UPDATE_USER_TOKEN } from "../../../utils/Api_enums";
import Pagination from "../../../components/pagination";
import { debounceQuery, TYPE_OF_CALL, TYPE_OF_ROLES, USER_HAS_BEEN_ENABLED, USER_TYPE_DROPDOWN } from "../../../utils/Constants";
import CustomHeader from "../../../CommonHeader/CustomHeader";
import { CustomTooltipFeature } from "ag-grid-community";
import { Translate } from "react-translated";


const { Search } = Input;
const { Option } = Select;

export const BUTTON_CONSTANTS = {
  edit_user: { label: "Edit User", key: "edit_user" },
  enable_user: { label: "Enable User", key: "enable_user" },
};

const InActiveSchedulers = (props) => {
  const { location } = props;
  const debounceRef = useRef(null);

  // sidebar usertype
  const { userType } = useBoundStore((state) => ({
    userType: state.userType,
  }));

  const searchTimeout = useRef(null);
  const [inActiveState, setInActiveState] = useState({
    loading: true,
    users: [],
    user: {},
    tableData: [],
    userType: [],
    searchText: "",
    filterColumnValue: "",
    filterColumnField: ""
  });

  const [currentState, setCurrentState] = useState({
    page: 1,
    total_pages: 0,
  });

  const [selectedUserType, setSelectedUserType] = useState([]);
  const [roles, setRoles] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const wrapperRef = useRef(null);
  const selectRef = useRef(null);



  // ----
  const [sortOrders, setSortOrders] = useState({});
  // state for localefield
  const [localField, setLocalField] = useState("updated_on");
  // state for localorder
  const [localOrder, setLocalOrder] = useState("desc");

  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleSort = (field) => {
    let newOrder;
    setSortOrders((prev) => {
      const currentOrder = prev[field] || "asc";
      newOrder = currentOrder === "asc" ? "desc" : "asc";
      return { ...prev, [field]: newOrder };
    });
    setLocalOrder(newOrder);
    setLocalField(field);
  };



  // table button action methods based on which button is clicked
  const handleButtonClick = (buttonType, data) => {
    if (buttonType === BUTTON_CONSTANTS.enable_user.key) {
      enableUser(data.id);
    }
  };


  const handleFilter = (field, value) => {
    setInActiveState(prev => ({
      ...prev,
      filterColumnValue: null,
      filterColumnField: null,
    }));

    if (field === 'type_of_Call') {
      setSelectedUserType(value);
    } else {
      setInActiveState(prev => ({
        ...prev,
        filterColumnValue: value,
        filterColumnField: field,
      }));
    }

    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      loadUsers(1);
    }, 500);
  };


  // --- Filter popover reset logic ---
  const resetHandlers = useRef([]);
  const handleFilterResetHandler = (resetFn) => {
    resetHandlers.current.push(resetFn);
  };


  const colDef = [
    {
      headerClass: 'custom-ag-header',
      headerName: "First Name",
      valueGetter: (params) => `${params.data.first_name || ""}`,
      sortable: true,
      headerComponent: CustomHeader,
      sortOrder: sortOrders["first_name"],
      headerComponentParams: (params) => ({
        headers: ["First Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "first_name",
        sortOrder: sortOrders["first_name"],
        handleSort,
        handleFilter,
        showPopOver: true,
        inputType: "text",
        handleFilterResetHandler
      }),
      colId: 'first_name',
      tooltipComponent: CustomTooltipFeature,
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Last Name",
      valueGetter: (params) => `${params.data.last_name || ""}`,
      sortable: true,
      headerComponent: CustomHeader,
      sortOrder: sortOrders["last_name"],
      headerComponentParams: (params) => ({
        headers: ["Last Name"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "last_name",
        sortOrder: sortOrders["last_name"],
        handleSort,
        handleFilter,
        showPopOver: true,
        inputType: "text",
        handleFilterResetHandler
      }),
      colId: 'last_name',
      tooltipComponent: CustomTooltipFeature
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Email",
      field: "email",
      sortable: true,
      width: 400,
      headerComponent: CustomHeader,
      sortOrder: sortOrders["email"],
      headerComponentParams: (params) => ({
        headers: ["Email"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "email",
        sortOrder: sortOrders["email"],
        handleSort,
        handleFilter,
        showPopOver: true,
        inputType: "text",
        handleFilterResetHandler
      }),
      colId: 'email',
      tooltipComponent: CustomTooltipFeature
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "User Type",
      field: "user_type",
      sortable: false,
      filter: false,
      headerComponentParams: (params) => ({
        headers: ["User Type"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "user_type",
        handleFilter,
        showPopOver: true,
        inputType: "select",
        options: F.getUserType(),
        handleFilterResetHandler
      }),
      colId: 'user_type',
      headerComponent: CustomHeader,
      cellRendererFramework: (params) => {
        const userType = params.value;
        let displayUserType = params.value;

        if (userType === "REVIEWSCHEDULER") {
          displayUserType = "RS";
        } else if (userType === "LSP") {
          displayUserType = "LSP";
        } else if (userType === "VONBOARDER") {
          displayUserType = "FS";
        } else if (userType === "VONSCHEDULER") {
          displayUserType = "RFS";
        }

        return (
          <div>
            <span
              style={{
                backgroundColor: "rgba(22, 72, 151, 0.12)",
                color: "#000",
                padding: "5px 5px",
                borderRadius: "7px",
              }}
            >
              {/* {params.value} */}
              {displayUserType}
            </span>
          </div>
        );
      },
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Type of Call",
      field: "type_of_Call",
      sortable: false,
      filter: false,
      width: 250,
      headerComponentParams: (params) => ({
        headers: ["Type of Call"],
        colDef: params.column.getColDef(),
        columnApi: params.columnApi,
        field: "type_of_Call",
        handleFilter,
        showPopOver: true,
        inputType: "multiCheckbox",
        options: F.getTypeOFCall(),
        handleFilterResetHandler
      }),
      colId: 'type_of_Call',
      headerComponent: CustomHeader,
    },
    {
      headerClass: 'custom-ag-header',
      headerName: "Actions",
      sortable: false,
      filter: false,
      cellRendererFramework: ActionButtonRenderer,
      width: 350,
      cellRendererParams: {
        onButtonClick: (buttonType, data) =>
          handleButtonClick(buttonType, data), // Pass as callback
        inActiveState,
      },
    },
  ];

  const getTypeOFCall = (user) => {
    const roles = user.roles;
    if (roles.length > 0) {
      const updatedRoles = roles.map((role) => TYPE_OF_CALL[role.rolename]);
      // console.log("updatedRoles",updatedRoles)
      return updatedRoles.join(",")
    }
    return ""
  }




  const loadUsers = async (page) => {
    let user = JSON.parse(Cookies.get("user_info"));
    const users_list = [];
    const data = [];
    const historyState = location;
    const filterColumnValue = inActiveState && inActiveState.filterColumnValue && inActiveState.filterColumnValue.trim();
    const filterColumnField = inActiveState && inActiveState.filterColumnField && inActiveState.filterColumnField.trim()
    // let api =
    // user.user_type == "SUPER_ADMIN" &&
    // historyState.state.user_type === "SUPER_ADMIN"
    //   ? "/api/inactive_users_sa"
    //   : `/api/inactive_users${(historyState.state.user_type &&
    //       "?user_type=" + historyState.state.user_type) ||
    //       ""}`;
    // this.setState({ loading: true });



    const nPage = page === undefined ? 1 : page;

    //  URL for loading users
    let url = `${INACTIVE_LOAD_USERS_API_URL}?page=${nPage}&sort_by=${localField}&sort_order=${localOrder}`;

    if (filterColumnValue && filterColumnField) {
      const filterObj = {};
      filterObj[filterColumnField.toLowerCase()] = filterColumnValue;
      url += `&filter_by_column_name=${encodeURIComponent(JSON.stringify(filterObj))}`;
    }

    // selecteduser roles check
    if (selectedUserType.length > 0) {
      // const 
      url += `&role_filter=${TYPE_OF_ROLES(selectedUserType)}`;
    }



    // Only add filters to the URL if the filters array is not empty
    if (inActiveState.searchText) {
      url += `&search_word=${encodeURIComponent(inActiveState.searchText)}`; // Add search_word if searchText exists
    }


    try {
      setInActiveState((prevState) => ({ ...prevState, loading: true }));
      const res = await axios.get(url)
      const users = res.data.inactive_users; // change key from invite to inactive  
      const table_data = users.map((user) => ({
        key: user.id,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        ...user,
        type_of_Call: getTypeOFCall(user),
      }));
      setInActiveState((prevState) => ({
        ...prevState,
        loading: true,
        tableData: table_data,
      }))
      setCurrentState((prevState) => ({
        ...prevState,
        page: res.data.page,
        total_pages: res.data.total_pages,
      }));

    } catch (error) {
      console.log("error", error);
      setInActiveState((prevState) => ({ ...prevState, loading: false }));
    } finally {
      setInActiveState((prevState) => ({ ...prevState, loading: false }));
    }


    // axios.get(api).then((res) => {
    //   const users = res.data.results;
    //   //   this.setState({ loading: false, users: Array.isArray(users) ? users : [] });
    //   for (let i = 0; i < users.length; i++) {
    //     let user = users[i];

    //     data.push({
    //       key: i,
    //       first_name: user.first_name,
    //       last_name: user.last_name,
    //       email: user.email,
    //       // user_type: user.user_type,
    //       user_type:
    //         user.user_type == "LSP (Onboarding & Life Licensed)" ||
    //         user.user_type == "LSP (Life Licensed)" ||
    //         user.user_type == "LSP (Onboarding)" ||
    //         user.user_type == "LSP"
    //           ? "Agency Staff"
    //           : user.user_type === "VONBOARDER"
    //           ? "Follow-Up Specialist"
    //           : user.user_type,
    //     type_of_Call: getTypeOFCall(user),
    //       user:user
    //     });
    //   }
    //   setInActiveState((prevState) => ({
    //     ...prevState,
    //     users: Array.isArray(users) ? users : [],
    //     loading: false,
    //     tableData: data,
    //   }));
    // }).catch((error) => {
    //     console.error("Error loading users:", error);
    //     setInActiveState((prevState) => ({
    //       ...prevState,
    //       loading: false,
    //     }));
    //   }).finally(() => {
    //     // this.setState({ loading: false });
    //     setInActiveState((prevState) => ({ ...prevState, loading: false }));
    //   });
  };

  const enableUser = (id) => {
    // this.setState({ loading: true });
    setInActiveState((prevState) => ({ ...prevState, loading: true }));
    axios
      // .put("/api/users/" + id, {
      //   active: 1,
      // })
      .put(UPDATE_USER_TOKEN + id)
      .then(() => {
        message.success(F.translate(USER_HAS_BEEN_ENABLED));
        // this.setState({ loading: false }, () => {
        //   this.loadUsers(1);
        // });
        setInActiveState((prevState) => ({ ...prevState, loading: false }));
        loadUsers(1);
      })
      .catch(() => {
        // this.setState({ loading: false });
        setInActiveState((prevState) => ({ ...prevState, loading: false }));
        message.error(F.translate(`Can't enable the user.`));
      });
  };

  const refreshInfo = () => {
    resetHandlers.current.forEach(reset => reset());
    setInActiveState((prevState) => ({
      ...prevState,
      searchText: "",
      filterColumnField: "",
      filterColumnValue: "",
      selectedUserType: [],
    }));
    setSelectedUserType([]);
    localStorage.removeItem("agGridColumnState");

    if (gridColumnApi) {
      gridColumnApi.resetColumnState();
      gridColumnApi.resetColumnGroupState();
    }

    loadUsers(1);
  }


  useEffect(() => {
    clearTimeout(debounceRef.current);

    const hasGlobalSearch = inActiveState.searchText.trim() !== "";
    const hasColumnFilter =
      inActiveState && (inActiveState.filterColumnField && inActiveState.filterColumnField.trim() !== "") &&
      (inActiveState.filterColumnValue && inActiveState.filterColumnValue.trim() !== "");

    debounceRef.current = setTimeout(() => {
      if (hasGlobalSearch || hasColumnFilter) {
        debounceQuery(() => loadUsers(inActiveState.page || 1), 500);
      } else {
        loadUsers(inActiveState.page || 1);
      }
    }, 500);

    return () => {
      clearTimeout(debounceRef.current);
    };
  }, [
    // inActiveState.page,
    localField,
    localOrder,
    inActiveState.searchText,
    inActiveState.filterColumnField,
    inActiveState.filterColumnValue,
    selectedUserType,
  ]);



  useEffect(() => {
    const getRoles = async () => {
      const { data: { roles } } = await axios.get(GET_ROLES_API);
      setRoles(roles.map(item => {
        return {
          label: TYPE_OF_CALL[item.rolename],
          value: TYPE_OF_CALL[item.rolename],
          role_id: item.role_id,
          // checked:false, 
        }
      }))
    }
    getRoles();
  }, [])



  const handleSearch = async (value) => {
    setInActiveState((prevState) => ({ ...prevState, searchText: value }))
    // debounceQuery(() => loadUsers(1), 500);
  }

  const customTagRender = (props) => {
    const { label, value, closable, onClose } = props;
    return (
      <Tag closable={closable} onClose={onClose}>
        {value}
      </Tag>
    );
  };



  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);

    const savedState = localStorage.getItem("agGridColumnState");
    if (savedState) {
      params.columnApi.applyColumnState({
        state: JSON.parse(savedState),
        applyOrder: true,
      });
    }
  }, []);

  const saveState = useCallback((params) => {
    const state = params.columnApi.getColumnState();
    localStorage.setItem("agGridColumnState", JSON.stringify(state));
  }, []);



  return (
    <div className="table-container">
      {/* Manage Schedulers header  */}
      <div className="manage-scheduler-header-container">
        <div>
          <Icon style={{ marginRight: 10, color: "#1890ff" }} type="usergroup-delete" />
          <span style={{ fontWeight: '600' }}>
            <Translate text="Inactive Schedulers" />
          </span>
        </div>

        <div className="input-container manage-scheduler-input-container" >

          {/* Search Input */}
          <div style={{ position: "relative" }} className="manage-scheduler-input-container" >
            <Input
              placeholder="Search by Name "
              value={inActiveState.searchText}
              onChange={(e) => {
                handleSearch(e.target.value)
              }}
              // style={{ width: 200 }}
              style={{ width: "100%", minWidth: '170px' }}
              className="searchinput borderRadius-28"
            />
            {inActiveState.searchText ? (
              <Icon
                type="close"
                onClick={() => handleSearch("")}
                className="icon-style right-10"
              />
            ) : (
              <Icon
                type="search"
                className="icon-style right-10"
              />
            )}
          </div>


          <div ref={wrapperRef}
            // style={{ position: "relative", width: 200 }}
            className="select-dropdown-container"
          >
            <Select
              ref={selectRef}
              open={dropdownOpen}
              onDropdownVisibleChange={(open) => setDropdownOpen(open)}
              mode="multiple"
              placeholder="Select Type of Call"
              maxTagCount={1}
              value={selectedUserType}
              onChange={(value) => {
                setInActiveState((prevState) => ({ ...prevState, userType: value }))
                setSelectedUserType(value)
              }}
              // style={{
              //   width: 200,
              //   backgroundColor: "#fff",
              //   borderRadius: "20px",
              //   fontSize: "12px",
              //   // border: "1px solid #cfc9c9",
              // }}
              className="searchinput user_type_select manage-scheduler-searchinput "
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }

              tagRender={customTagRender}
              optionLabelProp="value"
            >
              {
                roles.map((option) => (
                  <Option key={option.role_id} value={option.value}>{option.label}</Option>
                ))
              }
            </Select>
            <Icon
              type={dropdownOpen ? "up" : "down"}
              className="icon-style right-15"
              onClick={() => setDropdownOpen((prev) => !prev)}
            />
          </div>
          {/* <Button
            style={{
              background: "#164897",
              borderRadius: "10px",
              width: "10%",
            }}
            onClick={refreshInfo}
          >
            <img src={RefreshIcon} alt="Refresh" />
          </Button> */}

          <Button
            style={{
              marginTop: "0px"
            }}
            type='primary'
            className="bg-164897 borderRadius-28 myrefresh-btn"
            onClick={refreshInfo}
          >
            <Icon type="reload" />
            Refresh
          </Button>
        </div>
      </div>

      {/* Manage Schedulers Table  */}
      <div>
        {colDef.length > 0 && Array.isArray(inActiveState.tableData) ? (
          <Spin spinning={inActiveState.loading}>
            <CustomAgGridTable
              rowDatas={inActiveState.tableData}
              columnDefss={colDef}
              onGridReady={onGridReady}
              onColumnMoved={saveState}
              onSortChanged={saveState}
              onFilterChanged={saveState}
            />
          </Spin>
        ) : (
          <p>Loading...</p>
        )}
      </div>
      <div className="pagination-div-container">
        <Pagination
          className="pagination-container"
          current_page={currentState.page}
          total_pages={currentState.total_pages}
          onClick={(page) => {
            loadUsers(page)
          }}
        />
      </div>
    </div>
  );
};

export default withRouter(InActiveSchedulers);



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/InActive Schedulers/InActiveSchedulers.js